import React from 'react';
import { useParams, Link } from 'react-router-dom';
import styled from 'styled-components';
import blogsData from '../content/data/blogs.json';

const BlogDetailContainer = styled.div`
  max-width: 700px;
  margin: 0 auto;
  padding: 4rem 1.5rem 2rem;
`;

const BlogTitle = styled.h1`
  font-size: 2.25rem;
  margin-bottom: 1rem;
`;

const BlogMeta = styled.div`
  font-size: 0.95rem;
  color: var(--text-light);
  margin-bottom: 2rem;
`;

const BlogContent = styled.div`
  font-size: 1.15rem;
  line-height: 1.8;
  color: var(--text-dark);
  margin-bottom: 2rem;
`;

const BlogTags = styled.div`
  margin-bottom: 2rem;
  color: var(--accent-color);
  font-size: 0.95rem;
`;

const BlogDetail = () => {
  const { id } = useParams();
  const blog = (Array.isArray(blogsData) ? blogsData : []).find(b => b.id === id);

  if (!blog) return <BlogDetailContainer>Loading...</BlogDetailContainer>;

  return (
    <BlogDetailContainer>
      <BlogTitle>{blog.title}</BlogTitle>
      <BlogMeta>{blog.date} &middot; {blog.author}</BlogMeta>
      <BlogTags>
        {blog.tags && blog.tags.map(tag => (
          <span key={tag}>#{tag} </span>
        ))}
      </BlogTags>
      <BlogContent>{blog.content}</BlogContent>
      <Link to="/blog">&larr; Back to Blog</Link>
    </BlogDetailContainer>
  );
};

export default BlogDetail; 